export const setRevenue = function (state, payload) {
  state.revenue = payload;
};
